'use client';

import clsx from 'clsx';
import type { ForwardedRef } from 'react';
import { Separator as RACSeparator } from 'react-aria-components';
import { forwardRef } from '../../forward-ref.js';
import { withStyleProps } from '../../with-style-props.js';
import type { CommonProps } from '../types.js';

export interface DividerProps extends CommonProps {
  /**
   * The orientation of the divider (horizontal or vertical).
   * @default 'horizontal'
   */
  orientation?: 'horizontal' | 'vertical';
}

function Divider(
  { orientation = 'horizontal', UNSAFE_className, UNSAFE_style, ...props }: DividerProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <RACSeparator
      {...props}
      ref={ref}
      className={clsx('cim-divider', UNSAFE_className)}
      style={UNSAFE_style}
      elementType="div"
      orientation={orientation}
    />
  );
}

/** Renders a divider between adjacent content. */
const _Divider = withStyleProps(forwardRef(Divider), 'Divider');

export { _Divider as Divider };
